import MarketingPushNotificationFieldEpicClient from 'bundles/epic/clients/MarketingPushNotificationField';

// https://tools.coursera.org/epic/experiment/in1RQZ0UEe-qsQ6U4qJSNw
export const isMarketingPushNotificationFieldEnabledForCommunicationPreferences = () =>
  MarketingPushNotificationFieldEpicClient.get('show');
